import {addBusinessDays} from 'date-fns';
import {TbankSendDto} from '../../../global/api';
import {PrepareSendDtoProps} from '../types/balance-payment.types';

export const prepareSendDto = ({data, user, price}: PrepareSendDtoProps): TbankSendDto => {
  const invoiceDate = addBusinessDays(new Date(), 5).toISOString();
  const contactEmail = data?.email || user?.email;

  return {
    invoiceDate,
    dueDate: invoiceDate,
    payer: {
      name: data?.fullCompanyName,
      inn: data?.inn,
      kpp: data?.kpp,
    },
    contacts: contactEmail ? [{email: contactEmail}] : [],
    contactPhone: data?.phone,
    comment: data?.fullCompanyName ? `Счет на оплату для ${data?.fullCompanyName}` : `Счет на оплату`,
    items: [
      {
        amount: 1,
        name: 'Пополнение баланса личного кабинета',
        price,
        unit: 'Шт',
        vat: 'None',
      },
    ],
  };
};
